import React from 'react'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  className?: string
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, className = '', disabled, ...rest }, ref) => {
    const textareaClasses = [
      'w-full px-4 py-3 bg-white border border-silver/60 rounded-warm font-body text-ink min-h-[120px] resize-y',
      'placeholder:text-ink-muted/50',
      'transition-all duration-200',
      'focus:border-green focus:ring-2 focus:ring-green/20 outline-none',
      disabled ? 'opacity-50 cursor-not-allowed bg-silver-light/50' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <div className="w-full">
        {label && (
          <label className="block font-body text-sm font-medium text-ink-light mb-1.5">
            {label}
          </label>
        )}
        <textarea ref={ref} disabled={disabled} className={textareaClasses} {...rest} />
        {error && <p className="text-terra text-sm mt-1">{error}</p>}
      </div>
    )
  }
)

Textarea.displayName = 'Textarea'

export default Textarea
